<template>
    <div>
        <Loader ref="Loader"></Loader>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <YesNoModal ref="YesNoModal"></YesNoModal>
        <v-layout fill-height row mr-1 ml-1 mt-2>
            <v-flex xs12 sm12 md12 lg12 xl12>
                <v-card>
                    <v-card-text xs12 mt-3>
                        <v-layout v-for="venue in VenueList" :key="venue.Venue.ID" row wrap>
                            <v-toolbar color="primary" dark dense>
                                <v-spacer></v-spacer>
                                <v-toolbar-title>{{ venue.Venue.Name }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-flex xs12>
                                <v-layout row wrap ma-4>
                                    <v-flex xs12 sm12 md12 lg12 xl12>
                                        <v-card class="mb-5" color="grey lighten-5" elevation="4">
                                            <v-card-title>Create Ops-Manager Assessment Profile</v-card-title>
                                            <v-card-text>
                                                <v-layout justify-start row>
                                                    <v-flex xs2 mr-2 ml-2>
                                                        <v-checkbox v-model="venue.IsDefaultTemplate"
                                                            label="Default Assessment">
                                                        </v-checkbox>
                                                    </v-flex>
                                                    <v-flex mr-2 v-if="venue.IsDefaultTemplate == true">
                                                        <v-layout row wrap>
                                                            <v-flex xs10 sm10 md10 lg10 xl10>
                                                                <v-select v-model="venue.InspectionTemplate"
                                                                    label="Assessment Category"
                                                                    :items="InspectionTemplateTypes" item-text="Name"
                                                                    item-value="ID">
                                                                </v-select>
                                                            </v-flex>
                                                            <v-flex xs2 sm2 md2 lg2 xl2>
                                                                <v-btn fab small color="success"
                                                                    @click="CheckSelectedInspectionTemplate(venue, true)"
                                                                    :disabled="venue.InspectionTemplate == null">
                                                                    <v-icon>add</v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex mr-2 v-if="!venue.IsDefaultTemplate">
                                                        <v-layout row wrap>
                                                            <v-flex xs10 sm10 md10 lg10 xl10>
                                                                <v-text-field label="New Assessment Category Name"
                                                                    v-model="venue.CustomerInspectionName">
                                                                </v-text-field>
                                                            </v-flex>
                                                            <v-flex xs2 sm2 md2 lg2 xl2>
                                                                <v-btn fab small color="success"
                                                                    @click="AddCustomerInspectionTemplate(venue, true)"
                                                                    :disabled="venue.CustomerInspectionName == null">
                                                                    <v-icon>add</v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout justify-start row>
                                                    <v-flex xs2 mr-2 ml-2>
                                                        <v-checkbox v-model="venue.IsInspectionSelection"
                                                            label="Select From Inspections">
                                                        </v-checkbox>
                                                    </v-flex>
                                                    <v-flex mr-2 v-if="venue.IsInspectionSelection == true">
                                                        <v-layout row wrap>
                                                            <v-flex xs10 sm10 md10 lg10 xl10>
                                                                <v-select v-model="venue.SupervisorInspectionTemplate"
                                                                    label="Inspection" :items="SupervisorInspections"
                                                                    item-text="Name" item-value="ID">
                                                                </v-select>
                                                            </v-flex>
                                                            <v-flex xs2 sm2 md2 lg2 xl2>
                                                                <v-btn fab small color="success"
                                                                    @click="CheckSelectedInspectionTemplate(venue, false)"
                                                                    :disabled="venue.SupervisorInspectionTemplate == null">
                                                                    <v-icon>add</v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>

                                <!-- ASSESSMENT CARDS-->
                                <v-layout row wrap>
                                    <v-flex pa-2 xs12 md4 v-for="(inspectionItem, idx) in venue.Inspections" :key="idx">
                                        <v-card>
                                            <v-toolbar color="secondary" dark dense>
                                                <v-toolbar-title>{{inspectionItem.AssessmentCategory.Name}}
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-btn icon dark
                                                    @click="DeleteAssessmentCategory(inspectionItem.AssessmentCategory, inspectionItem, venue)">
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                            </v-toolbar>

                                            <v-card-text>
                                                <v-list>
                                                    <v-list-tile v-for="inspectionJob in inspectionItem.Assessments"
                                                        :key="inspectionJob.ID">
                                                        <v-list-tile-content>
                                                            <v-list-tile-title>{{ inspectionJob.Name }}
                                                            </v-list-tile-title>
                                                        </v-list-tile-content>
                                                        <v-list-tile-action>
                                                            <v-btn icon ripple
                                                                @click="DeleteAssessmentCategoryItem(inspectionJob, inspectionItem)">
                                                                <v-icon color="grey lighten-1">delete</v-icon>
                                                            </v-btn>
                                                        </v-list-tile-action>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-card-text>
                                            <v-layout justify-end>
                                                <v-btn medium flat fab
                                                    v-if="HasAccess('CUSTOMER_MANAGEMENT', 'CREATE')">
                                                    <v-icon color="success"
                                                        @click="ShowInspectionItemDialog(inspectionItem, inspectionItem.AssessmentCategory, venue)">
                                                        add_circle
                                                    </v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="AddInspectionItemDialog" width="650px" offset-x persistent>
            <v-form>
                <v-card>
                    <v-toolbar color="secondary" dark dense>
                        <v-toolbar-title>Add Inspection Item</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="AddInspectionItemDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-layout row ma-4>
                        <v-flex xs12>
                            <v-text-field v-model="InspectionName" label="Inspection" disabled></v-text-field>
                            <v-text-field v-model="InspectionItemName" label="New item name"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn color="primary" @click="AddInspectionItem()" :disabled="InspectionItemName == null">
                                Create</v-btn>
                            <v-btn flat @click="AddInspectionItemDialog = false">Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            let self = this;
            return {
                VenueList: [],
                AddInspectionItemDialog: false,
                InspectionTemplates: [],
                InspectionTemplateTypes: [],
                InspectionTemplateSelected: 0,
                CustomerInspectionItems: {
                    Name: null
                },
                InspectionName: null,
                InspectionItemName: null,
                Templates: [],
                customerInspectionID: 0,
                venueID: 0,
                tempItem: [],
                SupervisorInspections: [],
            }
        },
        props: ["CustomerID"],
        mounted() {
            let self = this;

            self.FetchVenues();
            self.FetchInspectionTemplates();
            self.FetchSupervisorInspections();
        },
        methods: {
            FetchVenues() {
                let self = this;
                self.get(`CustomerVenue/CustomerID?customerID=${self.CustomerID}`)
                    .then(r => {
                        r.data.forEach(venue => {
                            self.VenueList.push({
                                Venue: venue,
                                Inspections: []
                            })
                        });
                    })
                    .catch(error => {
                        console.log("VENUE:", error);
                    });
            },
            FetchSupervisorInspections() {
                let self = this;

                self.get(`CustomerInspections/GetByCustomer?customerID=${self.CustomerID}`).then(r => {
                    console.log("SUPERVISOR INSPECTIONZ", r.data)

                    r.data.forEach(el => {
                        self.SupervisorInspections.push(el.CustomerInspection);
                    })
                })
            },
            FetchInspectionTemplates() {
                let self = this;

                self.get('OpsManagerAssessments/AllGlobalCategoriesWithItems').then(r => {
                    self.InspectionTemplates = r.data;

                    self.InspectionTemplates.forEach(el => {
                        self.InspectionTemplateTypes.push(el.OpsManagerAssessmentCategory);
                    })
                })
            },
            CheckSelectedInspectionTemplate(venue, bool) {
                let self = this;
                var venueID = venue.Venue.ID;

                if (bool == true) {
                    var globalCategoryID = venue.InspectionTemplate;

                    self.post(
                            `CustomerAssessment/GlobalCategoryWithAssessments?customerID=${self.CustomerID}&venueID=${venueID}&globalCategoryID=${globalCategoryID}`
                        ).then(r => {
                            if (r.data == true) {
                                self.GetCustomerInspections(venue);
                                venue.InspectionTemplate = null;
                                venue.CustomerInspectionName = null;
                            }
                        })
                        .catch(error => {
                            self.$refs.ErrorModal.show();
                            self.$refs.ErrorModal.setText(error.toString());
                        });
                } else if (bool == false) {
                    var inspectionID = venue.SupervisorInspectionTemplate;

                    self.post(
                            `CustomerAssessment/FromCustomerInspections?customerID=${self.CustomerID}&venueID=${venueID}&inspectionID=${inspectionID}`
                        ).then(r => {
                            if (r.data == true) {
                                self.GetCustomerInspections(venue);
                                venue.SupervisorInspectionTemplate = null;
                                venue.IsInspectionSelection = false;
                            }
                        })
                        .catch(error => {
                            self.$refs.ErrorModal.show();
                            self.$refs.ErrorModal.setText(error.toString());
                        });
                }
            },
            GetCustomerInspections(venue) {
                let self = this;

                var venueID = venue.Venue.ID;
                venue.Inspections = [];
                self.$nextTick(() => {
                    self.get(
                        `CustomerAssessments/VenueCategoriesWithAssessments?venueID=${venueID}`
                    ).then(r => {
                        r.data.forEach(el => {
                            venue.Inspections.push(el)
                        })

                        self.tempItem = venue;
                    })
                })
            },
            AddCustomerInspectionTemplate(venue) {
                let self = this;

                let Request = {
                    CustomerID: self.CustomerID,
                    CustomerVenueID: venue.Venue.ID,
                    Name: venue.CustomerInspectionName
                }

                self.post('CustomerAssessments/CustomerCategory', Request).then(r => {
                        venue.CustomerInspectionName = null;
                        self.GetCustomerInspections(venue);
                    })
                    .catch(error => {
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText(error.toString());
                    });
            },
            ShowInspectionItemDialog(item, subItem, venue) {
                let self = this;

                self.tempItem = venue;
                self.InspectionName = item.AssessmentCategory.Name;
                self.venueID = item.AssessmentCategory.CustomerVenueID;
                self.customerInspectionID = item.AssessmentCategory.ID;
                self.AddInspectionItemDialog = true;
            },
            AddInspectionItem() {
                let self = this;

                let Request = {
                    CustomerAssessmentCategoryID: self.customerInspectionID,
                    Name: self.InspectionItemName
                }

                self.post('CustomerAssessments/CustomerAssessment', Request).then(res => {
                    self.$nextTick(() => {
                        self.GetCustomerInspections(self.tempItem)
                        self.AddInspectionItemDialog = false;
                        self.InspectionName = null;
                        self.InspectionItemName = null;
                    })

                })
            },
            DeleteAssessmentCategoryItem(item, subItem) {
                let self = this;

                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this assessment?",
                    function (yes) {
                        if (yes == true) {
                            self.$refs.Loader.show(true);
                            self.$refs.Loader.setText("Deleting item...");
                            self.delete(`CustomerAssessment/DeleteAssessment?id=${item.ID}`)
                                .then(result => {
                                    self.$refs.Loader.hide();
                                    if (result.data == true) {
                                        var index = subItem.Assessments.indexOf(item);
                                        if (index > -1) {
                                            subItem.Assessments.splice(index, 1);
                                        }
                                    }
                                })
                                .catch(error => {
                                    self.$refs.Loader.hide();
                                    self.$refs.ErrorModal.show();
                                    self.$refs.ErrorModal.setText(error.toString());
                                });
                        }
                    })

            },
            DeleteAssessmentCategory(subItem, inspectionItem, venue) {
                let self = this;

                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this category? All assessments within this category will also be deleted.",
                    function (yes) {
                        if (yes == true) {
                            self.$refs.Loader.show(true);
                            self.$refs.Loader.setText("Deleting item...");
                            self.delete(
                                    `CustomerAssessments/DeleteCategory?id=${inspectionItem.AssessmentCategory.ID}`)
                                .then(result => {
                                    self.$refs.Loader.hide();
                                    if (result.data == true) {
                                        self.GetCustomerInspections(venue);
                                    }
                                })
                                .catch(error => {
                                    self.$refs.Loader.hide();
                                    self.$refs.ErrorModal.show();
                                    self.$refs.ErrorModal.setText(error.toString());
                                });
                        }
                    })

            }
        }
    }
</script>

<style>

</style>